import React from 'react';
import { withCookies } from 'react-cookie';
import { Spin } from 'antd';
import { SearchBar, List, Toast } from 'antd-mobile';
import { Link } from 'react-router-dom';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

import "./index.css";
import styles from "./formlist.module.css";
import { _saveCommonForm, _listCommonForm, _updateCommonFormSort } from "../../server";

const Item = List.Item;
const Brief = Item.Brief;

const getItems = count =>
    Array.from({ length: count }, (v, k) => k).map(k => ({
        key: k,
        value: k
    }));

const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};

const grid = 5;

const getItemStyle = (isDragging, draggableStyle) => ({
    userSelect: "none",
    padding: grid * 2,
    margin: `0 10px ${grid}px 0`,

    border: isDragging ? "1px dashed #ff884d" : "none",

    ...draggableStyle
});

const getListStyle = (isDraggingOver, height) => ({
    border: isDraggingOver ? "1px dashed #ff884d" : "none",
    height: isDraggingOver ? height : "auto",
});

class FormCommonPage extends React.Component {

    constructor(props) {
        super(props)
        this.state = { forms: [], showFormInfoView: false, currentForm: {}, originList: [], isLoading: true };
        const { cookies } = this.props;
        this.sid = cookies.get(process.env.TOKEN_KEY);
        this.listCommonForm();

        this.onDragEnd = this.onDragEnd.bind(this);
    }

    async listCommonForm() {
        const res = await _listCommonForm(this.sid);
        if (res.code === 0) {
            this.setState({ forms: res.data.list, originList: [].concat(res.data.list) });
        }
        this.setState({ isLoading: false });
    }

    async saveCommonForm(isCommon) {
        const res = await _saveCommonForm(this.sid, this.state.currentForm.definitionId, isCommon);
        if (res.code === 0) {
            this.state.currentForm.isCommon = isCommon;

            this.state.forms.map(item => {
                if (this.state.currentForm.definitionId === item.definitionId) {
                    item.isCommon = isCommon;
                }
            });
            this.state.originList.map(item => {
                if (this.state.currentForm.definitionId === item.definitionId) {
                    item.isCommon = isCommon;
                }
            });

            this.setState({ forms: this.state.forms, originList: this.state.originList });

            if (isCommon === 1) {
                Toast.info('收藏为常用表单成功', 1);
            } else {
                Toast.info('取消常用表单成功', 1);
            }
        }
    }

    async _updateCommonFormSort(commonForms) {
        const res = await _updateCommonFormSort(this.sid, commonForms);
    }

    showFormInfo(e, item) {
        this.setState({ currentForm: item });
        this.setState({ showFormInfoView: true });
    }

    closeFormInfo = () => {
        this.setState({ showFormInfoView: false });
    }

    onDragEnd(result) {
        // dropped outside the list
        if (!result.destination) {
            return;
        }

        var forms = this.state.forms;
        const newSortForms = reorder(
            forms,
            result.source.index,
            result.destination.index
        );
        this.setState({ forms: newSortForms });
        var commonForms = [];
        for (var i = 0; i < newSortForms.length; i++) {
            commonForms.push(newSortForms[i].definitionId);
        }
        this._updateCommonFormSort(commonForms);
    }

    render() {
        return (
            <div className="wrap" style={{ overflowY: 'auto' }}>
                <SearchBar placeholder="搜索关键词" maxLength={20}
                    className={styles.my_searchBar}
                    onChange={(value) => {
                        if (value) {
                            let tmpArray = [];
                            this.state.originList.map((item) => {
                                if (item.formName.toUpperCase().indexOf(value.toUpperCase()) >= 0) {
                                    tmpArray.splice(tmpArray.length, 0, item);
                                }
                            })
                            this.setState({ forms: tmpArray });
                        } else {
                            this.setState({ forms: this.state.originList });
                        }
                    }} />
                {
                    this.state.isLoading ? <Spin style={{ width: "100%", marginTop: "60%" }} size="large" /> :
                        <List style={{ marginTop: 45 }} renderHeader={() => '常用表单（前4个表单显示在首页）'}>
                            {this.state.forms.length > 0 ? <DragDropContext onDragEnd={this.onDragEnd}>
                                <Droppable droppableId="droppable">
                                    {
                                        (provided, snapshot) => (
                                            <div {...provided.droppableProps}
                                                ref={provided.innerRef}
                                                style={getListStyle(snapshot.isDraggingOver, (this.state.forms.length + 1) * 52)}>
                                                {this.state.forms.map((item, index) => (
                                                    <Draggable key={item.definitionId} draggableId={item.definitionId} index={index} >
                                                        {(provided, snapshot) => (
                                                            <div ref={provided.innerRef}
                                                                {...provided.draggableProps}
                                                                {...provided.dragHandleProps}
                                                                style={getItemStyle(
                                                                    snapshot.isDragging,
                                                                    provided.draggableProps.style
                                                                )}
                                                                className={styles.formItem}
                                                                onClick={(e) => this.showFormInfo(e, item)}
                                                            >
                                                                <i className={[`${styles.iconFont}`, `${styles.bdShenpidan}`].join(' ')}></i>
                                                                <h3 className={styles.itemTitle}>{item.formName}</h3>
                                                                <i className={styles.dragbtn}></i>
                                                            </div>
                                                        )}
                                                    </Draggable>
                                                ))}
                                            </div>
                                        )}
                                </Droppable>
                            </DragDropContext>
                                : <div className="empty"><div className="img"></div><p className="desc">暂无数据</p></div>}
                        </List>
                }
                {
                    this.state.showFormInfoView ?
                        <div className="formInfo">
                            <div className="maskLayer" style={{ "opacity": this.state.showFormInfoView ? "0.4" : "" }} onClick={this.closeFormInfo}>

                            </div>
                            <div className="information">
                                <div className="popDragIcon"></div>
                                <div className="basicInformation">
                                    <div className="title">{this.state.currentForm.formName}</div>
                                    <div className="group">{this.state.currentForm.groupName}</div>
                                    <div className="basicInfoIcon">
                                        {
                                            this.state.currentForm.isCommon === 1 ? <i className="iconBasicInfo collected" onClick={() => {
                                                this.saveCommonForm(0);
                                            }}></i>
                                                : <i className="iconBasicInfo noCollected" onClick={() => {
                                                    this.saveCommonForm(1);
                                                }}></i>
                                        }
                                        {
                                            // <i className="iconBasicInfo iconMoreDetail"></i>
                                        }
                                    </div>
                                </div>
                                <div className="footer">
                                    <Link to={{ pathname: '/formdatalist', query: { definitionId: this.state.currentForm.definitionId } }}>
                                        <div className="detailData arrow"><i className="icon"></i>明细数据</div>
                                    </Link>
                                    {
                                        // <div className="statistical arrow"><i className="icon"></i>统计报表</div>
                                    }
                                    <Link to={{ pathname: '/formmain', query: { formId: this.state.currentForm.formId } }}>
                                        <div className="addForm">发起</div>
                                    </Link>
                                </div>
                            </div>
                        </div> : ""
                }
            </div>
        )
    }

}

export default withCookies(FormCommonPage);